import { Component, OnInit  } from '@angular/core';
import { Router } from '@angular/router';
import { Api, Session } from '../services/index';




@Component({
  selector: 'app-dashboard-whatwetreat',
  templateUrl: './dashboard-what-we-treat.html'
})



export class DashboardWhatWeTreat  {


  constructor(private router: Router, public session: Session) { 

    if(this.session.intakeLob === 'BH'){
      this.router.navigateByUrl('/bh-what-we-treat');
    }

  }
  ngOnInit(){
   
  }
	requestExam(){
		this.router.navigateByUrl('/exam-request-care-today');
  }
   
  gotoDashboard() {
		this.router.navigate(['/dashboard-medical/1']);
	}

  
}
